import React from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import {GLOBAL_ICONS} from "../../../../interface/icon";
import {Tr} from "../../../../layouts/tableLayout/_tr";
import {Th} from "../../../../layouts/tableLayout/_th";

const Thead = ({...props}) => {
  const {t} = useTranslation()
  return (
    <StyledThead>
      <Tr {...props} type="tHead" style={{ height: '44px' }}>
        <Th className="teacher-table__cell">ĐL cấp 2</Th>
        <Th className="teacher-table__cell">Email/Số điện thoại</Th>
        <Th className="teacher-table__cell">Tổng sản phẩm</Th>
        <Th className="teacher-table__cell">Tổng khách hàng</Th>
        <Th className="teacher-table__cell"
             // icon={<PaymentFilterPopover />}
        >
          Ngày tạo
        </Th>
        <Th className="teacher-table__cell">Trạng thái</Th>
        <Th className="teacher-table__cell" style={{display: 'flex'}}>
          {GLOBAL_ICONS.setting}
        </Th>
      </Tr>
    </StyledThead>
  )
}

export default Thead


export const StyledThead = styled.div`
  .teacher-table {
    &__cell {
      margin: 0 8px;
      display: flex;
      align-items: center;
      &:nth-child(1) {
        flex: 1;
      }
      &:nth-child(2) {
        width: 15%;
        justify-content: left;
      }
  
      &:nth-child(3) {
        width: 10%;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
  
      &:nth-child(4) {
        width: 12%;
        justify-content: center;
      }
  
      &:nth-child(5) {
        width: 10%;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
      &:nth-child(6) {
        width: 11%;
        text-align: center;
        justify-content: center;
        align-items: center;
      }
      &:nth-child(7) {
        width: 100px;
        padding-left: 20px;
      }
    }
  }
`
